KROWN.themeName = 'Split';
KROWN.themeVersion = '4.0.4';

const executeOnceOnDomContentLoaded = ()=>{

  // tab navigation

  let activeElement = document.activeElement;
  document.addEventListener('keyup', e=>{
    if ( e.keyCode == window.KEYCODES.TAB ) {
      if ( activeElement.classList.contains('focus') && e.target != activeElement ) {
        activeElement.classList.remove('focus');
      }
      if ( e.target.classList.contains('product-variant__input') ||
      	e.target.classList.contains('button') ||
      	e.target.classList.contains('product-item') ||
      	e.target.classList.contains('spr-summary-actions-newreview') ||
      	e.target.classList.contains('site-box-content-to-focus')
      ) {
        e.target.classList.add('focus');
      } 
      activeElement = document.activeElement;
    }
  });

  // newsletter has jump

  if ( window.location.pathname.includes('/challenge') ) {
    setTimeout(()=>{
      window.scroll({
        top: 0, 
        behavior: 'auto'
      });
    }, 300);
  }

  // fix image link borders

  document.querySelectorAll('.rte a img').forEach(elm=>{
    elm.parentNode.style.border = 'none';
  });

  // Filter handle
  
  if ( document.getElementById('site-filter-handle') ) {
    document.getElementById('site-filter-handle').addEventListener('click', e=>{
      e.preventDefault();
      document.getElementById('site-filters').show();
      document.getElementById('site-filter-handle').setAttribute('aria-expanded', 'true');
    });
  }

  // fix quick add to cart

  setTimeout(()=>{
    if ( document.querySelector('modal-box quick-view-product') ) {
      document.querySelector('modal-box quick-view-product').init();
    }
    if ( document.querySelector('modal-box quick-add-to-cart') ) {
      document.querySelector('modal-box quick-add-to-cart').init();
      document.querySelector('modal-box product-form').init();
    }
  }, 3050);

  // show newsletter popup confimation

  if ( document.location.search == '?customer_posted=true' && document.location.hash == '#newsletter-popup' && document.getElementById('modal-popup') ) {
    const newsletterPopup = document.getElementById('modal-popup');
    newsletterPopup.show();
    localStorage.setItem(newsletterPopup._modalKey, JSON.stringify({
      'shown': (new Date().getTime()),
      'content': newsletterPopup._modalText
    }));	
    setTimeout(()=>{
      newsletterPopup.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{newsletterPopup.hide(true)}));
    }, 100);
    clearTimeout(newsletterPopup._modalTimeout);
  }

  // custom cart listener
  
  if ( document.querySelector('cart-form') ) {
    document.querySelector('cart-form').addEventListener('cart-updated', ()=>{
      if ( document.body.classList.contains('template-cart') ) {

        if ( document.querySelector('#AjaxCartForm .subtitle') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = document.querySelector('#AjaxCartForm .subtitle').innerHTML;
        }
        if ( document.getElementById('AjaxCartSubtotal').querySelector('[data-cart-empty]') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = "";
          if ( ! document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
            document.getElementById('AjaxCartSubtotal').append(document.getElementById('section-cart').querySelector('template').content.cloneNode(true))
          } else {
            document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'block';
          }
        } else if ( document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
          document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'none';
        }

      }

      if ( document.querySelector('cart-recommendations') && parseInt(document.querySelector('[data-cart-count]').textContent ) == 0 ) {
        document.querySelector('cart-recommendations').innerHTML = '';
      }

    });
  }

  // recommended products listener

  if ( document.querySelector('#main-product-recommendations') ) {
    document.querySelector('#main-product-recommendations').addEventListener('product-recommendations-loaded', ()=>{
      eval(document.querySelector('#main-product-recommendations .js-fix-height').textContent);
    });
  }

}

if ( document.readyState !== 'loading' ) {
  executeOnceOnDomContentLoaded();
} else {
  document.addEventListener('DOMContentLoaded', executeOnceOnDomContentLoaded);
}

// ============ Announcement bar and Europe Site Redirection pop up code ================ // 

var location_json = "https://ipinfo.io?token=bd1b52a961e0eb";
var modal = document.getElementById('modal');
   
const twoHoursFromNow = new Date();
// alert(countryCode);



// Function to make the API call and store country info
function fetchCountryInfo() {
  // Check if the country info has already been fetched
  var countryCode = $.cookie('CountryCode');
  if (!countryCode) {
    console.log("entry");
    $.ajax({
      url: location_json,
      crossDomain: true,
      type: 'GET',
      async: false,
      dataType: 'json',
      success: function(response) {
        var country_code = response.country;
        var country_timezone = response.timezone;
        // Store the country code and timezone in cookies (you can also use localStorage)
        twoHoursFromNow.setTime(twoHoursFromNow.getTime() + 2 * 60 * 60 * 1000); // 2 hours in milliseconds
        // Format the date using toUTCString()
        const formattedDate = twoHoursFromNow.toUTCString();
        console.log(formattedDate,"formattedDate");
        
        document.cookie = "CountryCode=" + country_code + "; expires=" + formattedDate + "; path=/";

      // document.cookie = "CountryCode=" + country_code + "; expires=Mon Jul 31 2023 20:38:37 GMT+0530 (India Standard Time) path=/";
       // document.cookie = "CountryTimeZone=" + country_timezone + "; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/";

        // Set the flag to indicate that the country info has been fetched
        document.cookie = "CountryTimeZone=" + country_timezone + "; expires=" + formattedDate + "; path=/";

        document.cookie = "countryInfoFetched=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/";

        // Call the functions to handle announcements and pop-up, passing the country_code and country_timezone as arguments
        showAnnouncementBar(country_code);
        europianPopUp(country_timezone);
      }
    });
  } else {
    // If the country info has already been fetched, use the stored cookies for countryCode and countryTimeZone
    var countryCode = $.cookie('CountryCode');
    var countryTimeZone = $.cookie('CountryTimeZone');

    // Call the functions to handle announcements and pop-up using the stored country info
    showAnnouncementBar(countryCode);
    europianPopUp(countryTimeZone);
  }
}

// Call the function to fetch the country info on page load
fetchCountryInfo();

// showAnnouncementBar
function showAnnouncementBar(country_code){
     var announcementSlider = document.querySelector('.announcement-bar__slider');
      var announcements = announcementSlider.getElementsByClassName('announcement');
      var foundMatch = false;
     var otherValue = "";
      // Iterate over each announcement element
      for (var i = announcements.length - 1; i >= 0; i--) {
        var announcement = announcements[i];
        var countryCode = announcement.getAttribute('data-attr');
        var currencyCode = announcement.getAttribute('data-currency');
        var announcementElement = document.querySelector('.announcement[data-attr="Other"]');

// Initialize a variable to store the "Other" data-attr value

// otherValue = announcementElement.textContent.trim();
//         console.log("otherValue",otherValue);
        // Check if the country code matches
        if (countryCode === country_code || countryCode.includes(country_code)) {
          announcement.style.display = 'block';
          foundMatch = true;
        } else {
          announcement.remove(); // Remove the announcement element
        }
        
    // Store the "Other" data-attr value
    if (countryCode === 'Other') {
      otherValue = announcement.textContent.trim();
    }
      }

      // Hide the entire slider if no match is found
      if (!foundMatch) {
        // announcementSlider.style.display = 'block';
        if (otherValue !== "") {
      // If "Other" data-attr exists, show the custom text in the announcement bar
      var otherAnnouncement = document.createElement('div');
      otherAnnouncement.className = 'announcement';
      otherAnnouncement.textContent = otherValue;
      announcementSlider.appendChild(otherAnnouncement);
    } else {
      // If no "Other" data-attr, hide the announcement bar
      announcementSlider.style.display = 'none';
    }
      }
}

// For the Europien pop ip
function europianPopUp(countryTimeZone) {
   var countryCodeUk = $.cookie('CountryCode');
  if (countryTimeZone.indexOf('Europe') !== -1) {
 
         window.addEventListener('load', function() {
          var modal = document.getElementById('modal');
          var closeBtn = document.getElementsByClassName('close')[0];
          
          // Display the modal when the page loads
           if (isPopupClosed === 'true') {
          modal.style.display = 'none';
           } else if(countryCodeUk === "GB"){
               // console.log("countryCodecountryCode",countryCodeUk);
                modal.style.display = 'none';
            }
           else{
             modal.style.display = 'block';
           }
          // Close the modal when the close button is clicked
          closeBtn.addEventListener('click', function() {
            modal.style.display = 'none';
          });
          });
      }else{
        modal.style.display = 'none';
      }
    }

 // JavaScript code to handle the close button click
  var closeButton = document.getElementById('close-btn');
  closeButton.addEventListener('click', function() {
    // Perform actions when the close button is clicked
    document.getElementById('modal').style.display = 'none';
    // Set a cookie to remember that the pop-up has been closed
twoHoursFromNow.setTime(twoHoursFromNow.getTime() + 2 * 60 * 60 * 1000); // 2 hours in milliseconds

    // document.cookie = "popupClosed=" + country_timezone + "; expires=" + fiveMinutesFromNow.toGMTString() + "; path=/";

    document.cookie = "popupClosed=true; expires=" + twoHoursFromNow.toGMTString() + "; path=/";
  });

  // Check if the pop-up should be displayed based on the cookie
  var isPopupClosed = document.cookie.split(';').some(function(cookie) {
    return cookie.trim().startsWith('popupClosed=');
  });

  // Check if the pop-up should be displayed based on the cookie
var isPopupClosed = $.cookie('popupClosed');
 var countryCode = $.cookie('CountryCode');
 var countryTimeZone = $.cookie('countryTimeZone');
// alert(countryTimeZone); // Output the value of the 'CountryCode' cookie

if (countryCode) {
  // alert("in");
  showAnnouncementBar(countryCode);
  europianPopUp(countryTimeZone);
} else {
  // alert("Out");
  fetchCountryInfo();
  showAnnouncementBar(countryCode);
  europianPopUp();
}
// End
// ========= END =============== //